import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { SurgeryCategoryModel } from 'app/EMR/HistoryModels/surgery_Category.model';
import { ExportService } from 'app/reports/services/export.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-searchcategory',
  templateUrl: './searchcategory.component.html',
  styleUrls: ['./searchcategory.component.scss']
})
export class SearchcategoryComponent implements OnInit {

  destroydiagsea$: Subject<boolean> = new Subject<boolean>();
  private startdate: any;
  private enddate: any;
  private maxDate: any;
  private serachlistarray: any = {};
  private daigonisCategory_dslist = new MatTableDataSource<SurgeryCategoryModel>();
  private displayedColumns_departments: string[] = ['categoryName', 'department', 'icdCode', 'isActive'];
  constructor(private emrservice: EMRService, private exportdata: ExportService,
    private dashboardService: DashboardService,
    private authService: AuthService, private dialogRef: MatDialogRef<SearchcategoryComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
    //  this.data.enabledisablebtnMstCatDia
  }

  ngOnInit(): void {
    this.startdate = this.authService.getServerDate;
    this.enddate = this.authService.getServerDate;
    this.serachlistarray = {};
    this.maxDate = moment(this.authService.getServerDate).format('YYYY-MM-DD');
    this.getDiagonisisCategory(0);
    //  this.data.enabledisablebtnMstCatDia = false;
  }
  closedialog() {
    this.dialogRef.close(0);
  }

  getDiagonisisCategory(diaid) {
    this.emrservice.GetDiagonisCategory(diaid).pipe(takeUntil(this.destroydiagsea$)).subscribe(data => this.sucees_dagonis(data), err => this.err_daigonsis(err));
  }

  sucees_dagonis(data) {
    if (data.length > 0) {
      this.daigonisCategory_dslist.data = data;
    }

  }
  err_daigonsis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  applyFilter_grid(filterValue) {
    this.daigonisCategory_dslist.filter = filterValue.trim().toLowerCase();
  }

  selectRow(row) {

    this.dialogRef.close(row);
    //  this.data.enabledisablebtnMstCatDia = false;
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Diagnosis Master List');

  }

  ngOnDestroy() {
    this.destroydiagsea$.next(true);
    this.destroydiagsea$.unsubscribe();
    this.startdate = null;
    this.enddate = null;
    this.serachlistarray = null;
    this.maxDate = null;
    this.daigonisCategory_dslist = null;
    this.displayedColumns_departments = null;

  }
}
